import { SET_DSR_FIRST_CUSTOM_PAGE_ID } from '../../actions/dsr-actions-types'

const INITIAL_STATE_SET_FIRST_CUSTOM_PAGE_ID = { id: '' }

export function setFirstCustomPageIdReducer(state = INITIAL_STATE_SET_FIRST_CUSTOM_PAGE_ID, action) {
    switch (action.type) {
        case SET_DSR_FIRST_CUSTOM_PAGE_ID:
            return { id: action.payload };
        default:
            return state;
    }
}